import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=794aa5aa&"
import script from "./Pending.vue?vue&type=script&lang=ts&"
export * from "./Pending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports